import React, { useState, useEffect } from "react";
import * as validation from "../services/utils/validation"


const useFormWrapper = (send) => {
	/** Objects */
	const [inputs, setInputs] = useState({})
	const [validities, setValidities] = useState({})

	/** Variables */
	const [submitError, setSubmitError] = useState(null) // To capture error thrown when submittign form

	/** Booleans */
	const [isValid, setIsValid] = useState(false) // Only true if al inputs fulfill the rules and has no error
	const [isSending, setIsSending] = useState(false) // Only true while the submit process is running
	const [isSubmitted, setIsSubmitted] = useState(false) // Only true after form data has been successfully submitted

	const updateInput = (name, input) => {
		setInputs(inputs => ({ ...inputs, [name]: input }))
	}

	const removeInput = (name) => {
		let tempInput = inputs
		delete tempInput[name]
		setInputs({ ...tempInput })
	}

	const updateValidity = (name, validity) => {
		setValidities(validities => ({ ...validities, [name]: validity }))
	}

	const removeValidity = (name) => {
		let tempValidities = validities
		delete tempValidities[name]
		setValidities({ ...tempValidities })
	}

	useEffect(() => {
		let tempIsValid = true
		for (let [name, validity] of Object.entries(validities)) {
			tempIsValid = tempIsValid && validity
		}
		setIsValid(tempIsValid)
	}, [validities])




	return {
		updateInput,
		updateValidity,
		removeInput,
		removeValidity,
		//	submit,
		inputs,
		isValid,
		isSubmitted
	}
}

/** Form specific hooks for handling input forms and nested form structures */
const useForm = (init = null, send) => {
	/** Objects */
	const [inputs, setInputs] = useState(init && init.inputs ? init.inputs : {});
	const [errors, setErrors] = useState({});
	const [rules, setRules] = useState(init && init.rules ? init.rules : {})

	/** Variables */
	const [submitError, setSubmitError] = useState(null) // To capture error thrown when submittign form

	/** Booleans */
	const [isValid, setIsValid] = useState(false) // Only true if al inputs fulfill the rules and has no error
	const [isSending, setIsSending] = useState(false) // Only true while the submit process is running
	const [isSubmitted, setIsSubmitted] = useState(false) // Only true after form data has been successfully submitted

	const setInit = (init) => {
		if (init.inputs) {
			setInputs({ ...init.inputs })
		}
		if (init.rules) {
			setRules({ ...init.rules })
		}
		if (init.errors) {
			setErrors({ ...init.errors })
		}
	}

	const update = (name, value) => {
		setInputs(inputs => ({ ...inputs, [name]: value }))
	}

	const updateMultiple = (updates) => {
		setInputs(inputs => ({ ...inputs, ...updates }))
	}

	const updateError = (name, value) => {
		setErrors(errors => ({ ...errors, [name]: value }))
	}

	const removeInput = (name) => {
		let tempInputs = inputs
		delete tempInputs[name]
		setInputs({ ...tempInputs })
	}

	const handleChange = event => {
		event.persist();
		if (event.target.type === 'checkbox') {
			setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.checked }));
		} else {
			setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
		}
	}

	useEffect(() => {
		for (let [name, value] of Object.entries(inputs)) {
			validate(name, value)
		}
	}, [inputs])

	useEffect(() => {
		const tempIsValid = Object.values(errors).filter(value => value !== null).length === 0
		if (isValid !== tempIsValid) {
			setIsValid(tempIsValid)
		}
	}, [errors])

	const validate = (name, value) => {
		if (rules[name]) {
			for (let rule of rules[name]) {
				const error = validation[rule](value)
				if (error) {
					setErrors(errors => ({ ...errors, [name]: error }))
					break;
				} else {
					setErrors(errors => ({ ...errors, [name]: null }))
				}
			}
		}
	}


	// send = (inputs) => {return inputs}
	// TODO: expand to proper func
	const submit = () => {

	}

	return {
		inputs,
		errors,
		isValid,
		isSending,
		isSubmitted,
		submitError,
		setInit,
		update,
		updateMultiple,
		updateError,
		removeInput,
		handleChange,
		submit,
		isValid
	}
}

export { useForm, useFormWrapper }